import styled, { css } from 'styled-components'
import { colors } from '../../const'
import { withDisabledButtonStyled } from '../../const/styles'

export const Container = styled.div`
  font-family: 'Inter';
  margin: 0 auto;
  max-width: 1600px;
  padding: 4% 5% 2%;
  width: 100%;
`

export const Header = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 24px;
  width: 100%;
`

export const Title = styled.h1`
  color: ${colors.textPrimary};
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0;
`

export const MainContent = styled.section`
  background: ${colors.surface};
  border-radius: 5px;
  box-shadow:
    0px 1px 4px -1px rgba(0, 0, 0, 0.08),
    0px 3px 8px -1px rgba(0, 0, 0, 0.06),
    0px 6px 12px -1px rgba(0, 0, 0, 0.05);
  margin-top: min(2%, 26px);
  padding: min(2%, 32px);
  width: 100%;
`

export const ErrorMessage = styled.p`
  color: ${colors.error};
  font-size: 0.95rem;
  margin: 0 0 16px;
`

export const InformButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  border-radius: 6px;
  color: ${colors.primary};
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  width: 32px;

  &:hover {
    background: rgba(37, 99, 235, 0.1);
  }

  ${withDisabledButtonStyled}
`
